<template>
<div class="flex flex-wrap m16-theory aspect-ratio-9/21 md:aspect-ratio-square xl:aspect-ratio-4/3">
  <div class="flex flex-wrap justify-center content-between items-stretch text-center w-full flex-1 px-5 py-10 md:py-20 xl:px-32">
      <div class="hidden md:block md:w-3/12"></div>
      <div class="w-1/2 md:w-2/12 md:pb-10 text-2xl">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-2/12"></div>
      <div class="w-1/2 md:w-2/12">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-3/12"></div>
      
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverI: hoverEI }">
            I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverI: hoverEI }">
            I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      
      <div class="hidden md:block md:w-3/12"></div>
      <div class="w-1/2 md:w-2/12">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverI: hoverEI }">
            I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-2/12"></div>
      <div class="w-1/2 md:w-2/12">
        <div class="hover-wrapper">
          <div class="hover-wrapper">
          <a 
            @mouseover="hoverEI = true"
            @mouseleave="hoverEI = false" 
            href="theory/EI" 
            :class="{ hoverI: hoverEI }">
              I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverT: hoverTF }">T</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
        </div>
      </div>
      <div class="hidden md:block md:w-3/12"></div>
      
      <div class="hidden md:block md:w-3/12"></div>
      <div class="w-1/2 md:w-2/12">
          <div class="hover-wrapper">
          <a 
            @mouseover="hoverEI = true"
            @mouseleave="hoverEI = false" 
            href="theory/EI" 
            :class="{ hoverI: hoverEI }">
              I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-2/12"></div>
      <div class="w-1/2 md:w-2/12">
          <div class="hover-wrapper">
          <a 
            @mouseover="hoverEI = true"
            @mouseleave="hoverEI = false" 
            href="theory/EI" 
            :class="{ hoverI: hoverEI }">
              I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-3/12"></div>
      
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
            @mouseover="hoverEI = true"
            @mouseleave="hoverEI = false" 
            href="theory/EI" 
            :class="{ hoverI: hoverEI }">
              I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
            @mouseover="hoverEI = true"
            @mouseleave="hoverEI = false" 
            href="theory/EI" 
            :class="{ hoverI: hoverEI }">
              I</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      <div class="w-1/2 md:w-1/4">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverP: hoverJP }">P</a>
        </div>
      </div>
      
      <div class="hidden md:block md:w-3/12"></div>
      <div class="w-1/2 md:w-2/12 md:pt-10">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverS: hoverSN }">S</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-2/12"></div>
      <div class="w-1/2 md:w-2/12 md:pt-10">
        <div class="hover-wrapper">
          <a 
          @mouseover="hoverEI = true"
          @mouseleave="hoverEI = false" 
          href="theory/EI" 
          :class="{ hoverE: hoverEI }">
            E</a><a 
          @mouseover="hoverSN = true"
          @mouseleave="hoverSN = false" 
          href="theory/SN" 
          :class="{ hoverN: hoverSN }">N</a><a 
          @mouseover="hoverTF = true"
          @mouseleave="hoverTF = false" 
          href="theory/TF" 
          :class="{ hoverF: hoverTF }">F</a><a 
          @mouseover="hoverJP = true"
          @mouseleave="hoverJP = false" 
          href="theory/JP" 
          :class="{ hoverJ: hoverJP }">J</a>
        </div>
      </div>
      <div class="hidden md:block md:w-3/12"></div>
  </div>
</div>
</template>
}
<script>
export default {

  props: ['title', 'icon', 'description'],

  data () {
  return {
      hoverEI: false,
      hoverSN: false,
      hoverTF: false,
      hoverJP: false,
    }
  },
}
</script>